import {AppSettings} from '../constants';
import WorkOrderType from './Containers/manage-work-order-type';

export default [
  {
    path: '/work-order-type',
    component: WorkOrderType,
    private: true,
    menu: {
      name: 'Work order types',
      order: 6,
      group: 'Admin',
      subGroup: 'Other',
      icons: 'icon-work-order-types-ic',
      condition: () => {
        return AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI;
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/Work-Order-Type/routes.js